import { useUser } from "@accredo/fe-shared/hooks/user.js";
import policy from "../../policies/ClaimAttachmentPolicy.js";

export function useClaimAttachmentPermissions() {
  const { user } = useUser();
  return {
    canEdit: (attachment) => policy.edit({ user, attachment }),
    canToggleVisibility: (attachment) =>
      policy.toggleVisibility(user, attachment),
  };
}
